import type * as SearchPage from '../types/SearchPage'

export default function searchPageComponentParser(
  rawComponent: SearchPage.Raw,
): SearchPage.Parsed {
  const props = rawComponent.searchPage

  return {
    name: 'SearchPage',
    props,
  }
}
